import { render, staticRenderFns } from "./DepartmentAuthDialog.vue?vue&type=template&id=693b4070"
import script from "./DepartmentAuthDialog.vue?vue&type=script&lang=js"
export * from "./DepartmentAuthDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports